import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateAndUploadTranslationsRPC } from "./validateAndUploadTranslationsRPC";

export class ValidateAndUploadTranslationsRPCClientImpl extends ValidateAndUploadTranslationsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateAndUploadTranslationsRPC.Request): Promise<LeoRPCResult<ValidateAndUploadTranslationsRPC.Response, ValidateAndUploadTranslationsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/ValidateAndUploadTranslations",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateAndUploadTranslationsRPC.ResponseDTO,
      ValidateAndUploadTranslationsRPC.Errors.ErrorsDTO,
      ValidateAndUploadTranslationsRPC.Response,
      ValidateAndUploadTranslationsRPC.Errors.Errors
    >(
      response,
      "survey/ValidateAndUploadTranslations",
      ValidateAndUploadTranslationsRPC.Response.fromDTO,
      ValidateAndUploadTranslationsRPC.Errors.fromDTO
    );
  }
}
